
export const appConfig: any = {
    userIdle: 60 * 15,
    userIdleTimeOut: 60,
    userIdlePing: 60 * 2
};
